<template>
    <div>

        <v-stepper v-model='step' class="stepper-wizard">

            <v-stepper-header>

                <v-stepper-step color='#4ec5c1' :complete='step > 1' step="1">{{$t('stepper.step2')}}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step color='#4ec5c1' :complete='step > 2' step="2">{{$t('stepper.step3')}}</v-stepper-step>

            </v-stepper-header>

            <v-stepper-items >

                <v-stepper-content class="stepper-content-1" step="1">

                    <v-alert dense type="info" outlined color='primary'>
                        {{$t('stepper.alert')}}
                    </v-alert>
                    
                    <provider-config :omitCnpj='true' @updated='next' v-if="showProvider._id" />

                </v-stepper-content>

                <v-stepper-content  step="2">

                    <KM class="stepper-content-2" @uploadDone='upDone' @uploadFail='upFail' />

                </v-stepper-content>

            </v-stepper-items>

        </v-stepper>

    </div>
</template>

<script>

import KM from '../utils/Uploader/Uploader.vue'
import { mapGetters } from 'vuex';
import ProviderConfig from '../dashConfig/ProviderConfig.vue'

export default {

    name: 'WizardStepper',

    data() {
        return {

            step: 1,

        };
    },

    components: {
        KM,
        ProviderConfig,
    },

    computed: {
        ...mapGetters({ showProvider: 'ProviderVuex/provider' })
    },

    methods: {

        next() {

            if(this.step === 1) this.$emit('providerRegister')

            this.step = this.step + 1

        },

        back() {

            this.step = this.step - 1

        },

        upDone() {

            this.$emit('uploadDone')

        },

        upFail() {

            this.$emit('uploadFail')

        }

    }
}

</script>

<style scoped>

.route {

    width: 100%;
    height: 100%;

}

.stepper {

    margin-top: 10%;


}

.modal-back {

    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 2.59%, #FFEBDD 61.46%), #FAF7F2;
    box-shadow: 0 5px 6px rgba(0, 0, 0, 0.2), 0 3px 16px rgba(0, 0, 0, 0.12), 0 9px 12px rgba(0, 0, 0, 0.14);

} 



</style>
